import qs from 'querystring';

export function getQuery() {
  return qs.parse(location.search.slice(1)) || {};
}

export const addParamsToUrl = (srcUrl, param) => {
  const [base, query] = srcUrl.split('?');
  const o = qs.parse(query || '');
  const d = qs.stringify(Object.assign(o, param));

  if (d) {
    return `${base}?${d}`;
  }
  return base;
};

export const delParamsFromUrl = (targetUrl, keys) => {
  const [base, query = ''] = targetUrl.split('?');
  const o = qs.parse(query || '');
  keys.forEach((key) => {
    delete o[key];
  });

  return `${base}?${qs.stringify(o)}`;
};
